module.exports = __webpack_public_path__ + "img/2024-12-12a_2.b3754c57.jpg";